var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "rightcolumn" } }, [
    _c("div", { staticClass: "main" }),
    _c("div", { staticClass: "container" }, [
      !_vm.user.nickname
        ? _c("div", { staticClass: "Logout" }, [
            _c("p", [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.set_logout()
                    },
                  },
                },
                [_vm._v("登录")]
              ),
            ]),
          ])
        : _c("div", { staticClass: "user_info" }, [
            _c("div", { staticClass: "portrait" }, [
              _c("img", {
                attrs: { src: _vm._f("imgfilter")(_vm.user.avatar), alt: "" },
              }),
            ]),
            _c("div", { staticClass: "name hide" }, [
              _vm._v(_vm._s(_vm.user.nickname)),
            ]),
          ]),
      _c("div", { staticClass: "nav" }, [
        _c(
          "div",
          {
            staticClass: "nav_item knapsack",
            class: { active: this.$route.name == "officialWarehouse" },
            on: { click: _vm.toknapsack },
          },
          [
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.scrape > 0,
                    expression: "scrape>0",
                  },
                ],
              },
              [_vm._v(_vm._s(_vm.scrape))]
            ),
            _c("div", { staticClass: "text" }, [_vm._v("库存")]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }